export const scoreReportDraftLink = (draftId: number) => `/scoreReport?draftId=${draftId}`;
export const scoreReportEssayLink = (essayId: number) => `/scoreReport?essayId=${essayId}`;
export const scoreReportDraftAndPromptLink = (promptId: number, draftId?: number) =>
	`/scoreReport?draftId=${draftId}&promptId=${promptId}`;
